import {LocationSunTime} from '@/common/interfaces/location';
import {getNowDateWidthOffsetToLocal} from '@/common/helpers/date/getNowDateWidthOffsetToLocal';

export function checkIsNightNow(sunTime: LocationSunTime, timezoneOffset: number) {
	if (sunTime.isPolarDay) {
		return true;
	}

	if (sunTime.isPolarNight) {
		return true;
	}

	if (sunTime.sunrise === undefined || sunTime.sunset === undefined) {
		return false;
	}

	const date = getNowDateWidthOffsetToLocal(timezoneOffset);
	const totalMinutes = date.getHours() * 60 + date.getMinutes();
	return totalMinutes < sunTime.sunrise || totalMinutes > sunTime.sunset;
}
